<template lang="pug">
.v-courses.courses(v-if="data" :id="data?.id")
	v-mob-acc(:options="{mainSlot: {title: data.title, background: data.background, color: data.color, active: true}, converterSlot: data.converter}")
		template(#converterSlot)
			.courses__converter(v-if="data.converter")
				v-converter(:data-source="data.converter.data")
		template(#mainSlot)
			.courses__main
				.courses__title(v-if="data.title") {{data.title}}
				.courses__text(v-if="data.text") {{data.text}}
				.courses__table(v-if="data.headline")
					.courses__table-row
						.courses__table-cell(v-for="headline in data.headline") {{headline.text}}
					.courses__table-row(v-for="item in data.items")
						.courses__table-cell(v-for="headline in data.headline") {{item[headline.id]}}
				.courses__actions(v-if="data.actions")
					component.courses__action.btn(v-for="action in data.actions" type="button" :is="action.link ? 'a' : 'button'" :type="action.link ? '' : 'button'" :href="action.link" :class="action.className")
						v-svg-icon.btn__icon(v-if="action.icon" :icon="action.icon")
						| {{action.text}}
</template>

<script>
import sourceMixin from "./mixins/v-mixin-source.vue";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>